

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'





import F2 from '@antv/f2'
Vue.prototype.F2 = F2
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'


Vue.use(DatetimePlugin)
import XTable from 'vux/src/components/x-table/index.vue'

import Datetime from 'vux/src/components/datetime/index.vue'

import Cell from 'vux/src/components/cell/index.vue'

import Group from 'vux/src/components/group/index.vue'

import XButton from 'vux/src/components/x-button/index.vue'

import CellBox from 'vux/src/components/cell-box/index.vue'

import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'


import XInput from 'vux/src/components/x-input/index.vue'

import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import Countup from 'vux/src/components/countup/index.vue'


import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


import Sticky from 'vux/src/components/sticky/index.vue'

import Calendar from 'vux/src/components/calendar/index.vue'



import Alert from 'vux/src/components/alert/index.vue'

import Popup from 'vux/src/components/popup/index.vue'

import Confirm from 'vux/src/components/confirm/index.vue'


Vue.component('confirm', Confirm)
Vue.component('popup', Popup)
Vue.component('alert', Alert)


Vue.component('calendar', Calendar)
Vue.component('sticky', Sticky)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)

Vue.component('countup', Countup)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('x-input', XInput)

Vue.component('grid', Grid)
Vue.component('grid-item', GridItem)
Vue.component('cell-box', CellBox)
Vue.component('x-button', XButton)
Vue.component('group', Group)
Vue.component('cell', Cell)
Vue.component('datetime', Datetime)
Vue.component('x-table', XTable)



FastClick.attach(document.body)

Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js